var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.quotaAILimitReached
        ? _c(
            "div",
            { staticClass: "sellsy-ai" },
            [
              _c(
                "CompassTooltip",
                {
                  attrs: {
                    placement: "top",
                    delay: { show: 0, hide: 1 },
                    disabled: _vm.source === "bubblemenu"
                  }
                },
                [
                  _c("template", { slot: "content" }, [
                    _c("span", [_vm._v(_vm._s(_vm.tooltipLabelTranslate))])
                  ]),
                  _vm._v(" "),
                  _vm.source === "richtextmenu"
                    ? _c(
                        "CompassIconButton",
                        {
                          ref: "refTriggerPopoverLimitQuota",
                          attrs: { size: "small" },
                          on: {
                            click: function($event) {
                              _vm.displayPopoverLimitQuota = !_vm.displayPopoverLimitQuota
                            }
                          }
                        },
                        [
                          _c(
                            "template",
                            { slot: "default" },
                            [
                              _c("SaasIcon", {
                                attrs: {
                                  icon: "aiWrite",
                                  width: "16",
                                  height: "16"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    : _vm.source === "bubblemenu"
                    ? _c(
                        "button",
                        {
                          ref: "refTriggerPopoverLimitQuota",
                          staticClass: "sellsy-ai__button",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              _vm.displayPopoverLimitQuota = !_vm.displayPopoverLimitQuota
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "sellsy-ai__button-content" },
                            [
                              _c("SaasIcon", {
                                attrs: {
                                  icon: "aiWriteSquare",
                                  width: "16",
                                  height: "16"
                                }
                              }),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.labelIconTranslate) +
                                  "\n                "
                              )
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "CompassPopover",
                {
                  attrs: {
                    placement: _vm.getPlacementPopover,
                    customClass: "sellsy-ai__popover",
                    triggerRef: "refTriggerPopoverLimitQuota",
                    isVisible: _vm.displayPopoverLimitQuota
                  },
                  on: {
                    close: function($event) {
                      _vm.displayPopoverLimitQuota = false
                    },
                    open: _vm.handleVisibleChange
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "sellsy-ai__popover-container" },
                    [
                      _c("SaasIcon", {
                        attrs: { icon: "aiWarning", width: "16", height: "16" }
                      }),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass:
                            "label-limit-quota typographies-paragraph-small-regular"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.labelLimitQuotaTranslate) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("CompassPlainButton", {
                        attrs: {
                          label: _vm.labelButtonContactUsTranslate,
                          size: "small"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.handleContactUs($event)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _c(
            "CompassMenu",
            {
              staticClass: "sellsy-ai",
              attrs: {
                placement: _vm.getPlacementMenu,
                size: "small",
                customClass: "sellsy-ai__menu"
              },
              on: { open: _vm.handleVisibleChange }
            },
            [
              _c(
                "CompassTooltip",
                {
                  attrs: {
                    placement: "top",
                    delay: { show: 0, hide: 1 },
                    disabled: _vm.source === "bubblemenu"
                  }
                },
                [
                  _c("template", { slot: "content" }, [
                    _c("span", [_vm._v(_vm._s(_vm.tooltipLabelTranslate))])
                  ]),
                  _vm._v(" "),
                  _vm.source === "richtextmenu"
                    ? _c(
                        "CompassIconButton",
                        {
                          attrs: {
                            size: "small",
                            "data-bot": "ai-menu-" + _vm.sourceForLogs
                          }
                        },
                        [
                          _c(
                            "template",
                            { slot: "default" },
                            [
                              _c("SaasIcon", {
                                attrs: {
                                  icon: "aiWrite",
                                  width: "16",
                                  height: "16"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    : _vm.source === "bubblemenu"
                    ? _c(
                        "button",
                        {
                          staticClass: "sellsy-ai__button",
                          attrs: {
                            type: "button",
                            "data-bot": "ai-bubblemenu-" + _vm.sourceForLogs
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "sellsy-ai__button-content" },
                            [
                              _c("SaasIcon", {
                                attrs: {
                                  icon: "aiWriteSquare",
                                  width: "16",
                                  height: "16"
                                }
                              }),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.labelIconTranslate) +
                                  "\n                "
                              )
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "template",
                { slot: "dropdown" },
                [
                  _c("CompassMenuSubtitle", {
                    attrs: { label: _vm.menuSubtitleLabelTranslate.improve }
                  }),
                  _vm._v(" "),
                  _c("CompassMenuItem", {
                    attrs: {
                      label: _vm.menuItemsLabelTranslate.shorten,
                      icon: "ia-sumup",
                      disabled: _vm.isEmptyRichText,
                      "data-bot": "ai-shorten-" + _vm.sourceForLogs
                    },
                    on: {
                      click: function($event) {
                        return _vm.writerServiceAdapter({ task: "shorten" })
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("CompassMenuItem", {
                    attrs: {
                      label: _vm.menuItemsLabelTranslate.develop,
                      icon: "ia-develop",
                      disabled: _vm.isEmptyRichText,
                      "data-bot": "ai-develop-" + _vm.sourceForLogs
                    },
                    on: {
                      click: function($event) {
                        return _vm.writerServiceAdapter({ task: "develop" })
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "CompassMenuGroup",
                    {
                      attrs: {
                        label: _vm.menuItemsLabelTranslate.changeTone.default,
                        placement: "right-start",
                        icon: "ia-change-tone",
                        disabled: _vm.isEmptyRichText,
                        customClass: "sellsy-ai__menu-group"
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "dropdown" },
                        [
                          _c("CompassMenuItem", {
                            attrs: {
                              label:
                                _vm.menuItemsLabelTranslate.changeTone
                                  .professional,
                              "data-bot":
                                "ai-tone-professional-" + _vm.sourceForLogs
                            },
                            on: {
                              click: function($event) {
                                return _vm.writerServiceAdapter({
                                  tone: "professional"
                                })
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("CompassMenuItem", {
                            attrs: {
                              label:
                                _vm.menuItemsLabelTranslate.changeTone.informal,
                              "data-bot":
                                "ai-tone-informal-" + _vm.sourceForLogs
                            },
                            on: {
                              click: function($event) {
                                return _vm.writerServiceAdapter({
                                  tone: "informal"
                                })
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("CompassMenuItem", {
                            attrs: {
                              label:
                                _vm.menuItemsLabelTranslate.changeTone.friendly,
                              "data-bot":
                                "ai-tone-friendly-" + _vm.sourceForLogs
                            },
                            on: {
                              click: function($event) {
                                return _vm.writerServiceAdapter({
                                  tone: "friendly"
                                })
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("CompassMenuItem", {
                            attrs: {
                              label:
                                _vm.menuItemsLabelTranslate.changeTone
                                  .persuasive,
                              "data-bot":
                                "ai-tone-persuasive-" + _vm.sourceForLogs
                            },
                            on: {
                              click: function($event) {
                                return _vm.writerServiceAdapter({
                                  tone: "persuasive"
                                })
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("CompassMenuItem", {
                            attrs: {
                              label:
                                _vm.menuItemsLabelTranslate.changeTone.direct,
                              "data-bot": "ai-tone-direct-" + _vm.sourceForLogs
                            },
                            on: {
                              click: function($event) {
                                return _vm.writerServiceAdapter({
                                  tone: "direct"
                                })
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("CompassMenuItem", {
                            attrs: {
                              label:
                                _vm.menuItemsLabelTranslate.changeTone
                                  .informative,
                              "data-bot":
                                "ai-tone-informative-" + _vm.sourceForLogs
                            },
                            on: {
                              click: function($event) {
                                return _vm.writerServiceAdapter({
                                  tone: "informative"
                                })
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("CompassMenuItem", {
                    attrs: {
                      label: _vm.menuItemsLabelTranslate.correct,
                      icon: "ia-correct",
                      disabled: _vm.isEmptyRichText,
                      "data-bot": "ai-correct-" + _vm.sourceForLogs
                    },
                    on: {
                      click: function($event) {
                        return _vm.writerServiceAdapter({ task: "correct" })
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("CompassMenuItem", {
                    attrs: {
                      label: _vm.menuItemsLabelTranslate.improve,
                      icon: "ia-form",
                      disabled: _vm.isEmptyRichText,
                      "data-bot": "ai-improve-" + _vm.sourceForLogs
                    },
                    on: {
                      click: function($event) {
                        return _vm.writerServiceAdapter({ task: "improve" })
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "CompassMenuGroup",
                    {
                      attrs: {
                        label: _vm.menuItemsLabelTranslate.translate.default,
                        placement: "right-start",
                        icon: "ia-translate",
                        disabled: _vm.isEmptyRichText,
                        customClass: "sellsy-ai__menu-group"
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "dropdown" },
                        [
                          _c("CompassMenuItem", {
                            attrs: {
                              label:
                                _vm.menuItemsLabelTranslate.translate.english,
                              "data-bot":
                                "ai-translate-english-" + _vm.sourceForLogs
                            },
                            on: {
                              click: function($event) {
                                return _vm.writerServiceAdapter({
                                  language: "english"
                                })
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("CompassMenuItem", {
                            attrs: {
                              label:
                                _vm.menuItemsLabelTranslate.translate.german,
                              "data-bot":
                                "ai-translate-german-" + _vm.sourceForLogs
                            },
                            on: {
                              click: function($event) {
                                return _vm.writerServiceAdapter({
                                  language: "german"
                                })
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("CompassMenuItem", {
                            attrs: {
                              label:
                                _vm.menuItemsLabelTranslate.translate.spanish,
                              "data-bot":
                                "ai-translate-spanish-" + _vm.sourceForLogs
                            },
                            on: {
                              click: function($event) {
                                return _vm.writerServiceAdapter({
                                  language: "spanish"
                                })
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("CompassMenuItem", {
                            attrs: {
                              label:
                                _vm.menuItemsLabelTranslate.translate.italian,
                              "data-bot":
                                "ai-translate-italian-" + _vm.sourceForLogs
                            },
                            on: {
                              click: function($event) {
                                return _vm.writerServiceAdapter({
                                  language: "italian"
                                })
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("CompassMenuItem", {
                            attrs: {
                              label:
                                _vm.menuItemsLabelTranslate.translate.french,
                              "data-bot":
                                "ai-translate-french-" + _vm.sourceForLogs
                            },
                            on: {
                              click: function($event) {
                                return _vm.writerServiceAdapter({
                                  language: "french"
                                })
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.showWritingMenu
                    ? [
                        _c("CompassMenuSubtitle", {
                          attrs: {
                            label: _vm.menuSubtitleLabelTranslate.writing
                          }
                        }),
                        _vm._v(" "),
                        _c("CompassMenuItem", {
                          attrs: {
                            label: _vm.menuItemsLabelTranslate.prospect,
                            icon: "ia-prospecting",
                            disabled: _vm.disabled,
                            "data-bot": "ai-prospect-" + _vm.sourceForLogs
                          },
                          on: {
                            click: function($event) {
                              return _vm.writerServiceAdapter({
                                task: "prospect",
                                write: true
                              })
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("CompassMenuItem", {
                          attrs: {
                            label: _vm.menuItemsLabelTranslate.followUp,
                            icon: "ia-tracking",
                            disabled: _vm.disabled,
                            "data-bot": "ai-followup-" + _vm.sourceForLogs
                          },
                          on: {
                            click: function($event) {
                              return _vm.writerServiceAdapter({
                                task: "followUp",
                                write: true
                              })
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("CompassMenuItem", {
                          attrs: {
                            label: _vm.menuItemsLabelTranslate.reminder,
                            icon: "ia-reminder",
                            disabled: _vm.disabled,
                            "data-bot": "ai-reminder-" + _vm.sourceForLogs
                          },
                          on: {
                            click: function($event) {
                              return _vm.writerServiceAdapter({
                                task: "reminder",
                                write: true
                              })
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("CompassMenuItem", {
                          attrs: {
                            label: _vm.menuItemsLabelTranslate.promotion,
                            icon: "ia-promote",
                            disabled: _vm.disabled,
                            "data-bot": "ai-promotion-" + _vm.sourceForLogs
                          },
                          on: {
                            click: function($event) {
                              return _vm.writerServiceAdapter({
                                task: "promotion",
                                write: true
                              })
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("CompassMenuItem", {
                          attrs: {
                            label: _vm.menuItemsLabelTranslate.thanks,
                            icon: "ia-thank-you",
                            disabled: _vm.disabled,
                            "data-bot": "ai-thanks-" + _vm.sourceForLogs
                          },
                          on: {
                            click: function($event) {
                              return _vm.writerServiceAdapter({
                                task: "thanks",
                                write: true
                              })
                            }
                          }
                        })
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.source === "richtextmenu" && _vm.showAIQuotaUpsell
                    ? [
                        _vm.remainingQuotaAI && !_vm.loadingRemainingQuotaAI
                          ? _c("hr", {
                              staticClass: "sellsy-ai__menu__divider"
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.remainingQuotaAI && !_vm.loadingRemainingQuotaAI
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "sellsy-ai__menu__remaining-quota, sellsy-ai__menu__remaining-quota--hover",
                                on: { click: _vm.handleUpsell }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "sellsy-ai__menu__remaining-quota-label typographies-paragraph-x-small-semibold"
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.labelRemainingQuotaTranslate
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "sellsy-ai__menu__remaining-quota-upsell"
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "typographies-paragraph-x-small-regular"
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.upsellLabel) +
                                            "\n                        "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("CompassFeatureBadge", {
                                      attrs: {
                                        isInteractive: "",
                                        size: "extra-small",
                                        variant: "upsell"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _c("CompassSkeleton", { attrs: { size: "large" } })
                      ]
                    : _vm._e()
                ],
                2
              )
            ],
            2
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }